const MS_PER_SECOND = 1000;

export const readAccessTokenExpiry = (token: string): number | null => {
  const payloadSegment = token.split('.')[1];
  if (!payloadSegment) return null;

  try {
    const base64 = payloadSegment.replace(/-/g, '+').replace(/_/g, '/');
    const paddedBase64 = base64.padEnd(
      Math.ceil(base64.length / 4) * 4,
      '=',
    );
    const payload = JSON.parse(window.atob(paddedBase64)) as { exp?: unknown };
    return typeof payload.exp === 'number'
      ? payload.exp * MS_PER_SECOND
      : null;
  } catch {
    return null;
  }
};
